import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';
import Glide from './glide';

(function ($) {

    entityID = "5f25854a-b848-427c-8f5f-e634f0984fa8"; //ngenic
    singleViewURL = "/investor-relations/pressrelease/";

    var setupMobileNav = function () {

        $('a#show_navigation').click(function (e) {
            e.preventDefault();
            $('body').toggleClass('display-mobile-nav');
        });

    }

    var setupSortimentSearch = function () {

        // Make :contains case insensitive
        jQuery.expr[':'].contains = function (a, i, m) {
            return jQuery(a).text().toUpperCase()
                .indexOf(m[3].toUpperCase()) >= 0;
        };

        $('#sortiment_search').keyup(function () {

            var searchTerm = $.trim($(this).val());

            if (searchTerm === '') {
                $('.sortiment-column').show();
                $('.sortiment-no-results').hide();
                $('.sortiment-search-clear').hide();
            }
            else {
                $('.sortiment-search-clear').show();
                $('a.sortiment-filter').removeClass('active');
                $('.sortiment-column').hide();
                $('.sortiment-no-results').hide();
                $('.sortiment-column .meta:contains("' + searchTerm + '")').parents('.sortiment-column').show();
                $('.sortiment-column .title-small-alt:contains("' + searchTerm + '")').parents('.sortiment-column').show();
                $('.sortiment-column .description-text:contains("' + searchTerm + '")').parents('.sortiment-column').show();

                var metaResult = $('.sortiment-column .meta:contains("' + searchTerm + '")').length;
                var titleResult = $('.sortiment-column .title-small-alt:contains("' + searchTerm + '")').length;
                var descriptionResult = $('.sortiment-column .description-text:contains("' + searchTerm + '")').length;
                var totalResult = metaResult + titleResult + descriptionResult;
                if (totalResult === 0) {
                    $('.sortiment-no-results').show();
                }
            }

        });

        // Clear search on click on X
        $('a.sortiment-search-clear').click(function (e) {
            e.preventDefault();
            $('#sortiment_search').val('');
            $('.sortiment-search-clear').hide();
            $('.sortiment-column').show();
            $('.sortiment-no-results').hide();
            $('a.sortiment-filter').removeClass('active');
        });

    }


    var setupSortimentFilters = function () {


        $('a.sortiment-filter').click(function (e) {
            e.preventDefault();

            var filter = $(this).data('filter');
            var searchTerm = $.trim($('#sortiment_search').val());

            $('.sortiment-no-results').hide();


            if ($(this).hasClass('active')) {
                $(this).removeClass('active');

                $('.sortiment-grid').hide().fadeIn('250');
                $('.sortiment-column').show();
            }
            else {
                $('a.sortiment-filter').removeClass('active');
                $(this).addClass('active');

                if (searchTerm) {
                    $('.sortiment-grid').hide().fadeIn('250');
                    $('.sortiment-column').hide();
                    $('.sortiment-column').each(function () {
                        if ($(this).is(filter) && $(this).is(':contains("' + searchTerm + '")')) {
                            $(this).show();
                        }
                    });

                    if (!$('.sortiment-column:visible').size()) {
                        $('.sortiment-no-results').show();
                    }

                }
                else {
                    $('.sortiment-grid').hide().fadeIn('250');
                    $('.sortiment-column').hide();
                    $('.sortiment-column').each(function () {
                        if ($(this).is(filter)) {
                            $(this).show();
                        }
                    });
                }
            }



        });

    }


    var setupCompatibilityForm = function () {

        var heatsystemArray = new Array();
        var brandArray = new Array();
        var modelArray = new Array();
        var selectedObject = new Array();


        var serviceUp = function () {
            $('.form-fields').removeClass('disabled');
            $('.form-fields .spinner').remove();
        }

        var serviceDown = function () {
            $('.form-fields select').remove();
            $('.form-fields .spinner').remove();
            $('.info-error').removeClass('hide');
        }

        var getFormData = function () {
            var xhr;
            if (window.XMLHttpRequest) {
                xhr = new XMLHttpRequest();
            }
            else {
                xhr = new ActiveXObject("Microsoft.XMLHTTP");
            }
            xhr.open('GET', "https://app.ngenic.se/api/v2/heatsystems", true);
            xhr.onload = function () {
                var status = xhr.status;
                if (status === 200) {
                    heatsystemArray = JSON.parse(xhr.responseText);
                    serviceUp();
                } else {
                    serviceDown();
                }
            };
            xhr.send();
        }

        getFormData();

        var getSelectedHeatSystem = function () {
            // Disable brand and model in case of system change
            $('#select-brands').attr('disabled', 'disabled');
            $('#select-models').attr('disabled', 'disabled');

            // In case of select-model is hidden
            showSelectModelWrapper();

            // Hide result
            resetVisibleResult();

            // Get value of selected heatsys
            var e = document.getElementById("select-heatsystems");
            var selectedHeatsys = e.options[e.selectedIndex].value;

            // Show hide extra info for AirWaterHeatPumps
            if (selectedHeatsys == "AirWaterHeatPump") {
                $('.info-airwaterheatpump').removeClass('hide');
            }
            else {
                $('.info-airwaterheatpump').addClass('hide');
            }

            // Filter out all heatsys with type other than the selected        
            brandArray = heatsystemArray.filter(function (item) {
                return item.type == selectedHeatsys;
            });

            // Clear previous options if heatsys is changed, but keep the first option
            var el = document.getElementById("select-brands");
            if (el.options.length > 1) {
                for (var j = el.options.length; j > 0; j--) {
                    el.remove(j);
                }
            }

            var ele = document.getElementById("select-models");
            if (ele.options.length > 1) {
                for (var k = ele.options.length; k > 0; k--) {
                    ele.remove(k);
                }
            }

            var uniqueBrandArray = [];

            for (var i = 0; i < brandArray.length; i++) {
                // We only need the brand name one time
                if (uniqueBrandArray.indexOf(brandArray[i].manufacturer) == -1) {
                    uniqueBrandArray.push(brandArray[i].manufacturer);
                }

                // If this is the last item
                if (i == brandArray.length - 1) {
                    // Sort brands ASC
                    uniqueBrandArray.sort();

                    // Populate select-brand with options
                    for (var ia = 0; ia < uniqueBrandArray.length; ia++) {
                        var option = document.createElement("option");
                        option.text = uniqueBrandArray[ia];
                        option.value = uniqueBrandArray[ia];
                        el.add(option);
                    }
                }
            }

            // Enable (undisable) select brand
            $('#select-brands').attr('disabled', false);
        }


        var getSelectedBrand = function () {
            // In case of select-model is hidden
            showSelectModelWrapper();

            // If this is a retry, make sure info-box is showing if it's supposed to
            shouldInfoBoxBeVisible();

            // Disable model in case of brand change
            $("#select-models").attr('disabled', true);

            // Reset previous result
            resetVisibleResult();

            // Get value of selected brand
            var e = document.getElementById("select-brands");
            var heatType = document.getElementById("select-heatsystems");
            var selectedBrand = e.options[e.selectedIndex].value;
            var selectedHeatsystem = heatType.options[heatType.selectedIndex].value;


            if (selectedHeatsystem == "GroundHeatPump" && selectedBrand == "IVT") {
                $('.info-ivt').removeClass('hide');
            }
            else {
                $('.info-ivt').addClass('hide');
            }

            // Filter out all brands with manufacturer other than the selected
            modelArray = brandArray.filter(function (item) {
                return item.manufacturer == selectedBrand;
            });

            // Sort modelArray on 'model' ASC
            modelArray = modelArray.sort(function (a, b) {
                if (a['model'] === b['model']) {
                    return 0;
                }
                else {
                    return (a['model'] < b['model']) ? -1 : 1;
                }
            });


            // Clear previous options if brand is changed, but keep the first option
            var el = document.getElementById("select-models");
            if (el.options.length > 1) {
                for (var j = el.options.length; j > 0; j--) {
                    el.remove(j);
                }
            }

            for (var i = 0; i < modelArray.length; i++) {
                var option = document.createElement("option");
                option.text = modelArray[i].model;
                option.value = modelArray[i].model;
                el.add(option);
            }

            // Enable (undisable) select model
            $("#select-models").attr('disabled', false);

            // If there is only 1 model and it's not supported, select it
            if (modelArray.length == 1 && !modelArray[0].isSupported) {
                // Fix for Elpanna -> Thermia, having a blank model name (that's also not supported)
                if (modelArray[0].model == "") {

                    $("#select-models").attr('disabled', true);
                }
                else {
                    document.getElementById("select-models").value = modelArray[0].model;
                }
                // Hide model-select if this one system is not supported

                hideSelectModelWrapper();

                //$('.form-fields select').hide();
                $('.info-airwaterheatpump').addClass('hide');
                $('.info-ivt').addClass('hide');

                getSelectedModel();
            }

            // Enable (undisable) select brand
            $("#select-brands").attr('disabled', false);
        }

        var getSelectedModel = function () {

            // Reset previous result
            resetVisibleResult();

            // Get value of selected model
            var e = document.getElementById("select-models");
            var selectedModel = e.options[e.selectedIndex].value;

            selectedObject = modelArray.filter(function (item) {
                return item.model == selectedModel;
            });

            /* Ugly only to keep support for IE 9 */
            var element, arr;
            if (selectedObject[0].isSupported) {
                $('.has-support').removeClass('hide');

                // Hide all selects
                $('.form-fields select').hide();
                $('.info-airwaterheatpump').addClass('hide');
                $('.info-ivt').addClass('hide');
                // Set choosen heatsys name
                $('.selected-name').text($('#select-brands option:selected').text() + ' ' + $('#select-models option:selected').text());
                $('.selected-type').text($('#select-heatsystems option:selected').text());
                console.log(selectedObject[0].heatSystemId);
                $('.has-support a.button').attr('href', $('.has-support a.button').data('url') + '?id=' + selectedObject[0].heatSystemId);

            }
            else {
                $('.has-no-support').removeClass('hide');
            }
        }


        var shouldInfoBoxBeVisible = function () {
            // Only and always show info-box if heatsys type is AirWater..
            var e = document.getElementById("select-brands");
            var heatType = document.getElementById("select-heatsystems");
            var selectedBrand = e.options[e.selectedIndex].value;
            var selectedHeatsystem = heatType.options[heatType.selectedIndex].value;


            if (selectedHeatsystem == "AirWaterHeatPump") {
                $('.info-airwaterheatpump').removeClass('hide');
            }
            else {
                $('.info-airwaterheatpump').addClass('hide');
            }

            if (selectedHeatsystem == "GroundHeatPump" && selectedBrand == "IVT") {
                $('.info-ivt').removeClass('hide');
            }
            else {
                $('.info-ivt').addClass('hide');
            }


        }

        var hideSelectModelWrapper = function () {
            // Hide model-select
            $('#select-models').hide();
        }
        var showSelectModelWrapper = function () {
            $('#select-models').show();
        }

        var resetVisibleResult = function () {
            $('.has-no-support').addClass('hide');
            $('.has-support').addClass('hide');
        }

        var resetForm = function () {
            event.preventDefault();
            document.getElementById("select-models").value = "";
            shouldInfoBoxBeVisible();
            resetVisibleResult();
            $('.form-fields select').show();
        }


        $('#select-heatsystems').on("change", getSelectedHeatSystem);
        $('#select-brands').on("change", getSelectedBrand);
        $('#select-models').on("change", getSelectedModel);
        $("a#edit-form").on('click', function (event) { event.preventDefault(); resetForm(); });

    }

    var initDisclaimer = function () {

        $('a#confirm-disclaimer').click(function (e) {
            e.preventDefault();
            $('#disclaimer').remove();
            $('.page-default').removeClass('hidden');
            window.scrollTo(0, 0);
        });

        $('a#no-confirm-disclaimer').click(function (e) {
            e.preventDefault();
            $('#disclaimer').remove();
            $('#no-confirm').removeClass('hidden');
            window.scrollTo(0, 0);
        });
    }

    var initSupportToggle = function () {

        $('#support-nav a').click(function (e) {
            e.preventDefault();
            var supportSection = $(this).data('support');

            $('#support-nav a').removeClass('active');
            $(this).addClass('active');

            $('.support-option').addClass('hidden');
            $('#' + supportSection).removeClass('hidden');
            $('html, body').animate({
                scrollTop: $('#' + supportSection).offset().top
            }, 250);
        });


    }

    var initMFNSinglePost = function () {
        // Implements the MFN-JS Loader javascript file
        if (!window._MFN) {
            var s = document.createElement("script");
            s.type = "text/javascript";
            s.src = "https://widget.datablocks.se/api/rose/assets/js/mfn/mfn-js-loader-v0.1.0.js";
            s.async = true;
            document.getElementsByTagName("body")[0].appendChild(s);
        }

        window._MFN = {

            // The selector of the element where the content of the
            // single news item should end up
            outlet: '#mfn_container_single',

            // The type of view
            type: 'singleview',

            // Default language of the news item shown
            lang: 'sv',

            // 'selected' uses locale from lang, other options are 'en', 'sv'
            // and so on
            l10nLang: 'selected',

            // Author Entity ID provided
            entity_id: entityID,

            // If it should show date
            show_date: true,

            // 'default' or eg [{tag: ':regulatory'}]
            show_tags: 'default',

            // Should most likely be true
            use_proxied_attachment_urls: true,

            // Show attachments
            show_attachments: true,

            // if attachments should be displayed as thumbnails (Default as links)
            show_attachment_thumbnail: true,

            // attachment thumbnail size (max size of 585).
            // (To ensure high quality thumbnails, we recommend using max size
            // and then setting the CSS class of the img to half the size)
            attachment_thumbnail_size: 585

        }
    }

    var initMFNSignup = function () {

        if ($('#subscribe-module').length) {
            (function (wid) {
                window._MF = {
                    data: wid,
                    url: "https://widget.datablocks.se/api/rose",
                    ready: !!0,
                    render: function () {
                        window._MF.ready = !0
                    }
                };
                var b = document.createElement("script");
                b.type = 'text/javascript';
                b.async = true;
                b.src = window._MF.url + "/assets/js/loader-v2.js";
                document.getElementsByTagName("body")[0].appendChild(b)
            })([{
                query: "#subscribe-module"
                , widget: "subscribe"
                , locale: "sv"
                , token: "30ffd40e-529c-4fe1-803b-c5968e60961a"
                , c: "3f446f60-a725-409f-8742-4633cd7f50f0"
            }]
            );
        }

    }


    var initMFNLists = function () {

        // Implements the MFN-JS Loader javascript file
        if (!window._MFN) {
            var s = document.createElement("script");
            s.type = "text/javascript";
            s.src = "https://widget.mfn.se/v1/serve/assets/js/mfn-loader-v0.1.5.js";
            s.async = true;
            document.getElementsByTagName("body")[0].appendChild(s);
        }

        window._MFN = [{
            // The selector of the element where the content of the news
            // archive should end up
            outlet: '#mfn_container',

            // Default language of the news items shown
            lang: 'all',

            // 'selected' uses locale from lang, other options are 'en', 'sv'
            // and so on
            l10nLang: 'sv',

            // The type of view
            type: 'listview',

            // Author Entity ID provided
            feed_id: entityID,

            // Path to the page where a single view version has been implemented
            single_view_url: singleViewURL,

            // Enable if you want to activate a disclaimer page for news items
            // of a specific tag
            //disclaimer_redirect_tag: 'cus:disclaimer',
            //disclaimer_redirect_url: 'disclaimer.html',

            // Default limit of items shown
            limit: 6,

            // Adds the preamble of the article
            show_preamble: false,

            // 'default' (:regulatory, sub:report:annual, sub:report:interim)
            // or add your own eg [{tag: ':regulatory'}]
            show_tags: [{ tag: ':regulatory' }],

            // Show attachments
            show_attachments: false,

            // Enable clickable tags
            clickable_tags: true,

            // Toolbar
            toolbar: [
                // 'default' or [{tag: ':regulatory'},
                // {tag: 'sub:report:interim'}] etc.
                { item: 'tags', tags: [{ tag: ':regulatory' }] }
                //{item: 'year', start: 2010}
            ],
            // Your own local to override text selection or add for
            // other l10n languages (For the toolbar text and tags)
            l10n: {
                'Next': {
                    en: 'Next',
                    sv: 'Tidigare',
                },
                'Previous': {
                    en: 'Previous',
                    sv: 'Senare',
                }
            },

            // Show additional filter info, default: false
            show_info: false,
            // Show not found element, default: false
            show_notfound: true,

            // Override default 'not found' element
            notfound_tmpl: {
                en: '<div class="mfn-notfound"><span>Couldn\'t find any press releases.</span></div>',
                sv: '<div class="mfn-notfound"><span>Kunde inte hitta några pressmeddelanden.</span></div>'
            },

            // Should most likely be true (Enables proxy attachments)
            use_proxied_attachment_urls: true,

            // Shows the date
            show_date: true,

            // Example of configuring locale and time zone,
            // Swedish timezone is default if date_setting is not set
            date_setting: {
                locale: 'sv-SE', // eg. for US 'en-US',
                option: {
                    month: 'long', // or 'long', 'short'
                    year: 'numeric', // or '2-digit'
                    day: 'numeric', // or '2-digit'
                    timeZone: 'Europe/Stockholm' // eg. 'America/New_York'
                }
            }

            // If you want to implement your own custom date formatter
            // you can add your own function
            // format_date: function(date) {
            //     return date.toLocaleTimeString('sv-SE', {
            //         month: 'long',
            //         year: 'numeric',
            //         day: 'numeric',
            //         timeZone: 'Europe/Stockholm'
            //     });
            // }

            // Example of implementing your own HTML for a news item
            // post_processor: function(current, item) {
            //  console.log(item)
            //     return '<div>' + item.content.title + '</div>'
            // }

        },
        {
            // The selector of the element where the content of the report
            // archive should end up
            outlet: '#mfn_reports',

            // Default language of the report items shown
            lang: 'sv',

            // The type of view
            type: 'listview',

            // Feed ID, provided by MFN
            feed_id: entityID,

            // Default limit of items shown
            limit: 500,

            tags: ["sub:report"],

            mutators: ["report-period"],

            currentYear: '',

            // Report type translations
            l10n: {
                'annual': {
                    en: 'Annual Report',
                    sv: 'Årsredovisning',
                },
                'yearendreport': {
                    en: 'Year-end Report',
                    sv: 'Bokslutskommuniké',
                },
                'interim': {
                    en: 'Interim',
                    sv: 'Delårsrapport',
                },
                'correction': {
                    en: 'Correction',
                    sv: 'Rättelse',
                }
            },

            // Should most likely be true (Enables proxy attachments)
            use_proxied_attachment_urls: true,

            post_processor: function (current, item) {
                var lang = item.properties.lang;

                var year = "";

                var y = item.extensions && item.extensions.report_period.from.slice(0, 4) || '*';

                this.currentYear = y;

                var primaryAttachment = item.content.attachments && item.content.attachments.find(function (a) {
                    return a.tags && a.tags.includes(':primary');
                });

                if (!primaryAttachment) {
                    return year;
                }

                var tags = item.properties.tags || [];

                var isAnnualReport = tags.find(function (t) {
                    return t.indexOf('sub:report:annual') !== -1;
                });
                var isYearEndReport = tags.find(function (t) {
                    return t.indexOf('sub:report:interim:q4') !== -1;
                });
                var isCorrection = tags.find(function (t) {
                    return t.indexOf(':correction:') !== -1;
                });
                var reportTagsArr = tags.filter(function (t) {
                    return t.indexOf('sub:report') !== -1;
                });

                var longestReportTag = reportTagsArr.length > 0 ? reportTagsArr.reduce(function (a, b) {
                    return a.length > b.length ? a : b;
                }) : "report:unknown";

                var quarter = (longestReportTag.split(":").slice(-1)[0]).toUpperCase();

                var genericTitle = isAnnualReport ? this.l10n.annual[lang] + " " : this.l10n.interim[lang] + " ";
                genericTitle += isAnnualReport ? "" : quarter;
                isYearEndReport ? genericTitle = this.l10n.yearendreport[lang] + " " + quarter + " " : genericTitle;
                genericTitle += " ";
                genericTitle += y;
                genericTitle += (isCorrection ? " (" + this.l10n.correction[lang] + ")" : "");

                var longDate = item.content.publish_date;
                var shortDate = longDate.substring(0, longDate.length - 10);

                var attachmentLink = '<li>';
                attachmentLink += '<span class="date">' + shortDate + '</span><a href="' + primaryAttachment.url + '" target="_blank">' + genericTitle + '</a>';
                attachmentLink += '</li>';

                return attachmentLink;
            }
        }]
    }
		
		var initGlideSlideshowDefault = function () {
			
			var sliders = document.querySelectorAll('.glide-slideshow-default');

			for (var i = 0; i < sliders.length; i++) {
			  var glide = new Glide(sliders[i], {
					gap: 30,
					perView:3,
					bound:true,
					rewind:false,
					keyboard:false,
					peek: {
						before: 30,
						after: 170
					},
					breakpoints: {
						1310: {
							perView: 3,
							peek: {
								before: 30,
								after:100
							}
						},
						1200: {
							perView: 2,
							peek: {
								before: 30,
								after:250
							}
						},
						1000: {
							perView: 2,
							peek: {
								before: 30,
								after:80
							}
						},
						800: {
							gap: 30,
							perView: 1,
							peek: {
								before: 30,
								after: 200
							}
						},
						600: {
							gap: 30,
							perView: 1,
							peek: {
								before: 30,
								after: 60
							}
						}
					}
			  });
  
			  glide.mount();
			}
			
		}
		
		var initGlideSlideshowThreeColumns = function () {
			
			var sliders = document.querySelectorAll('.glide-slideshow-3-col');

			for (var i = 0; i < sliders.length; i++) {
			  var glide = new Glide(sliders[i], {
					gap: 30,
					perView:3,
					bound:true,
					rewind:false,
					keyboard:false,
					peek: {
						before: 30,
						after: 30
					},
					breakpoints: {
						1200: {
							perView: 2,
							peek: {
								before: 30,
								after: 250
							}
						},
						1100: {
							perView: 2,
							peek: {
								before: 30,
								after: 80
							}
						},
						850: {
							perView: 2,
							peek: {
								before: 30,
								after: 60
							}
						},
						800: {
							perView: 1,
							peek: {
								before: 30,
								after: 200
							}
						},
						600: {
							perView: 1,
							peek: {
								before: 30,
								after: 60
							}
						}
					}
			  });
  
			  glide.mount();
			}
			
		}
		
		var initGlideSlideshowRelated = function () {
			
			var sliders = document.querySelectorAll('.glide-slideshow-related');

			for (var i = 0; i < sliders.length; i++) {
			  var glide = new Glide(sliders[i], {
					gap: 30,
					perView:4,
					bound:true,
					rewind:false,
					keyboard:false,
					peek: {
						before: 0,
						after: 0
					},
					breakpoints: {
						1200: {
							perView: 3,
							peek: {
								before: 0,
								after: 100
							}
						},
						1100: {
							perView: 2,
							peek: {
								before: 0,
								after: 200
							}
						},
						1000: {
							perView: 2,
							peek: {
								before: 30,
								after: 200
							}
						},
						820: {
							perView: 2,
							peek: {
								before: 30,
								after: 100
							}
						},
						700: {
							perView: 2,
							peek: {
								before: 30,
								after: 80
							}
						},
						650: {
							perView: 1,
							peek: {
								before: 30,
								after: 120
							}
						},
						400: {
							perView: 1,
							peek: {
								before: 30,
								after: 60
							}
						}
					}
			  });
  
			  glide.mount();
			}
			
		}
		
		var initAccordionToggle = function() {
			
      $('.accordion-trigger').click(function () {
				
				if(!$(this).parent().parent().hasClass('collapsed')) {					
					$(this).parent().parent().siblings('.collapsed').children('.accordion-content').slideUp("fast", function() {
						$(this).parent('.collapsed').removeClass('collapsed')
					});
					
					$(this).parent().siblings('.accordion-content').slideDown("fast", function() {
						$(this).parent().addClass('collapsed');
					});
					
				}
				else {
					$(this).parent().parent().children('.accordion-content').slideUp("fast", function() {
						$(this).parent('.collapsed').removeClass('collapsed')
					});
				}
				
      });

		}
		
		
		var checkCartCount = function() {
			
      function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }

      var cookieExists = getCookie("itemsInCart");

      if (cookieExists && getCookie("itemsInCart") > "0") {
				$('#shopping_cart').attr('href', $('#shopping_cart').data('cart-url')).addClass('has-items');
				$('#shopping_cart span').text(getCookie("itemsInCart"));
				$('#shopping_cart_mobile').attr('href', $('#shopping_cart').data('cart-url')).addClass('has-items');
				$('#shopping_cart_mobile span').text(getCookie("itemsInCart"));
      }
			
			//$('#shopping_cart').attr('href', $('#shopping_cart').data('cart-url')).addClass('has-items');
			//$('#shopping_cart span').text('3');
			//$('#shopping_cart_mobile').attr('href', $('#shopping_cart').data('cart-url')).addClass('has-items');
			//$('#shopping_cart_mobile span').text('3');

		}
		
		
		var initStickyNav = function() {
			
			// Hide Header on on scroll down
			var didScroll;
			var lastScrollTop = 0;
			var delta = 100;

			$(window).scroll(function(event){
			    hasScrolled();
			});

			
			function hasScrolled() {
			    var st = $(this).scrollTop();
					
					// position > lastScrollTop && position > delta
			    if(st > lastScrollTop && st > delta){
			        // Scroll Down
			        $('.header-sticky').removeClass('stickynav-show').addClass('stickynav-hide');
			    }
					else {
			    	// Scroll Up
			      if(st + $(window).height() < $(document).height()) {
							if(st > delta) {
								$('.header-sticky').removeClass('stickynav-hide').addClass('stickynav-show');
							}
							else {
								$('.header-sticky').removeClass('stickynav-hide').removeClass('stickynav-show');
							}
			      	
			      }
			    }
    
			    lastScrollTop = st;
			}
			
		}
		
		

    $(document).ready(function () {


        // Video overlay
        $('.video-fullscreen').click(function (e) {
            if (e.target.id != "video") {
                $(this).hide();
                $('#video').get(0).pause();
                $('#video').get(0).currentTime = 0;
            }
        });

        // Video trigger
        $('.video-play').click(function (e) {
            e.preventDefault();

            $('.video-fullscreen').fadeIn('250');
            setTimeout(function () { $('#video').get(0).play(); }, 400);

        });


        // FAQ toggle
        $('.question a').click(function (e) {
            e.preventDefault();

            $(this).parent().next('.answer').toggle();
            $(this).parent().toggleClass('expanded');
        });

        // Init MFN pressreleases + reports
        if ($('#mfn_container').length) {
            initMFNLists();
        }

        // Init MFN pressreleases + reports
        if ($('#mfn_container_single').length) {
            initMFNSinglePost();
        }

        // Init MFN newsletter module
        if ($('#subscribe-module').length) {
            initMFNSignup();
        }

        // Disclaimer popup
        if ($('#disclaimer').length) {
            initDisclaimer();
        }

        // Compatibility
        if ($('#compatibility_form').length) {
            setupCompatibilityForm();
        }

        // Sortiment
        if ($('#sortiment_search').length) {
            setupSortimentSearch();
        }

        if ($('#sortiment-filters').length) {
            setupSortimentFilters();
        }


        // Support toggle
        if ($('#support-nav').length) {
            initSupportToggle();
        }

        // Toggle mobile navigation
        if ($('#show_navigation').length) {
            setupMobileNav();
        }
				
        // Init Glide Slideshow Default
        if ($('.glide-slideshow-default').length) {
            initGlideSlideshowDefault();
        }
				
        // Init Glide Slideshow 3 columns
        if ($('.glide-slideshow-3-col').length) {
            initGlideSlideshowThreeColumns();
        }
				
        // Init Glide Slideshow Related
        if ($('.glide-slideshow-related').length) {
            initGlideSlideshowRelated();
        }
				
        // Init Accordion toggle
        if ($('.accordion-wrapper').length) {
            initAccordionToggle();
        }
				
        // checkCartCount
        if ($('#shopping_cart').length) {
            checkCartCount();
        }
				
        // checkCartCount
        if ($('#header.header-sticky').length) {
            initStickyNav();
        }
				

        initAjaxPostForForms();

        window.addEventListener('CookiebotOnAccept', function (e) {
            if (Cookiebot.consent.marketing) {
                initCookieServices()
            } 
        }, false);
        window.addEventListener('CookiebotOnDecline', function (e) {
            if (!Cookiebot.consent.marketing) {
                clearCampaignCookies();
            } 
        }, false);

        $('#routerLink').click(() => {
            Cookiebot.renew();
        });
    });

    $(window).on('load', () => {
        if(!Cookiebot.consented) {
            clearCampaignCookies();
        }
    });

    function initCookieServices() {
        (function (w, d, s, l) {
            w[l] || (w[l] = {
                track: function (e, o) {
                    (w[l].q = w[l].q || []).push({
                        trackingEvent: e,
                        onSuccess: o.onsuccess,
                        runAt: +new Date()
                    })
                }
            });
            e = d.createElement(s);
            r = d.getElementsByTagName(s)[0];
            e.src = '/wp-content/themes/wordpress-theme-ngenic-v2/assets/js/ngenic-tracking.js?v=' + (1e7 + Math.random() * 1e7);
            r.parentNode.insertBefore(e, r)
        }(window, document, 'script', 'ng'));

        handleCampaign();
    }

    const _defaultOptions = {
        querystring_parameter: 'tracking_campaign',
        cookie_nameprefix: 'ng-tracking.identifier__',
        cookie_expire: 30,
        cookie_samesite: 'lax',
        cookie_domain: 'ngenic.se',
        cookie_secure: true,
        cookie_path: '/',
    };

    const options = Object.assign({}, _defaultOptions, window.NG_CAMPAIGN_TRACKING ?? {});

    function handleCampaign() {
        const qsValues = getQueryStringValues(document.location.search);
        if (!qsValues || !qsValues[options.querystring_parameter]) return;

        const campaignName = qsValues[options.querystring_parameter];
        if (!campaignName) return;

        const campaignIdentifierCookieName = `${options.cookie_nameprefix}_${campaignName}`;
        if (!Cookies.get(campaignIdentifierCookieName)) {
            const campaignIdentifier = uuidv4();

            const pageName = document.location.pathname
                .split('/')
                .filter(s => s !== '')
                .shift() || 'homepage';

            if (!['tune', 'track', 'homepage'].includes(pageName))
                return;

            const event = {
                "SourceApplication": 'ngenic.se',
                "CampaignName": campaignName,
                "Name": `Incoming click (${pageName})`,
                "Identifier": campaignIdentifier,
                "Timestamp": new Date().toISOString()
            }

            ng.track(event, {
                onsuccess: () => {
                    Cookies.set(
                        campaignIdentifierCookieName,
                        campaignIdentifier,
                        {
                            domain: options.cookie_domain,
                            path: options.cookie_path,
                            expires: options.cookie_expire,
                            secure: options.cookie_secure,
                            sameSite: options.cookie_samesite
                        }
                    );
                }
            });
        }
    }

    function clearCampaignCookies() {
        const allCookies = Cookies.get();
        
        for (const key of Object.keys(allCookies)) {
            if (!key.startsWith(options.cookie_nameprefix)) continue;

            Cookies.remove(key, {
                domain: options.cookie_domain,
                path: options.cookie_path
            });
        }
    }

    function getQueryStringValues(searchString) {
        if (!searchString) return null;

        return searchString.substring(1)
            .split('&')
            .reduce((values, kv) => {
                const segments = kv.split('=');
                values[decodeURIComponent(segments[0])] = decodeURIComponent(segments[1]);
                return values;
            }, {});
    }

    function initAjaxPostForForms() {
        if (window.wpcf7)
            window.wpcf7.blocked = true;

        $('form.wpcf7-form').each((_, form) => {
            form.removeAttribute('action');
            form.removeAttribute('method');
            form.removeAttribute('novalidate');
            form.removeAttribute('enctype');

            const inputs = [...form.querySelectorAll('input')];

            inputs.forEach(input => {
                if (input.getAttribute('aria-required') === 'true') {
                    input.required = true;
                }
            });

            $(form).on('submit', (event) => {
                event.stopImmediatePropagation();
                event.preventDefault();

                const customOptionNames = ['type'];

                const customOptions = inputs.filter(x => customOptionNames.includes(x.name))
                    .reduce((options, input) => {
                        const normalizedName = input.name.replace(/-(\S)/gi, (_, char) => char.toUpperCase());
                        options[normalizedName] = input.value;
                        return options;
                    }, {});

                customOptions['locale'] = document.documentElement.lang.replace("-", "_");
                customOptions['origin'] = document.location.toString();

                const formData = inputs.filter(x => !customOptionNames.includes(x.name) && !x.name.startsWith("_wpcf7"))
                    .reduce((formData, input) => {
                        switch (input.type) {
                            case 'button':
                            case 'image':
                            case 'reset':
                            case 'submit':
                                break;
                            case "checkbox":
                            case "radio":
                                if (input.checked)
                                    formData.append(input.name, input.value);
                                break;
                            case 'select-multiple':
                                for (const option of input.selectedOptions) {
                                    formData.append(option.name, option.value);
                                }
                                break;
                            default:
                                formData.append(input.name, input.value);
                                break;
                        }
                        return formData;
                    }, new FormData());

                submitAjaxRequestForForm(event.target, formData, customOptions);
            });
        })
    }

    async function submitAjaxRequestForForm(form, formData, options) {
        const queryString = Object.entries(options)
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join('&');

        try {
            const response = await fetch(`https://website-app.ngenic.se/api/website/webform-emails?${queryString}`, {
                method: 'POST',
                body: formData
            });
            if (!response.ok) {
                const json = await response.json();
                setFormStatus(form, 'failed');

                switch (json.status) {
                    case 400:
                        setFormStatusMessage(form, 'misconfigured');
                        break;
                    case 500:
                        setFormStatusMessage(form, 'general');
                        break;
                }

                console.error("Server returned error: %o", json.errors);
                return;
            }
            setFormStatus(form, 'sent');
            setFormStatusMessage(form, 'sent');
        } catch (_) {
            setFormStatus(form, 'failed');
            setFormStatusMessage(form, 'general');
        }
    }

    function setFormStatus(form, newStatus) {
        const validStatuses = ['init', 'resetting', 'submitting', 'failed', 'aborted', 'spam', 'invalid', 'unaccepted', 'payment-required', 'sent'];
        if (!validStatuses.includes(newStatus))
            console.error(`Status "${newStatus} not supported on Contact Form 7`);

        form.wpcf7.status = newStatus;
        form.setAttribute('data-status', newStatus);
        validStatuses.forEach(status => form.classList.remove(status));

        form.classList.add(newStatus);
    }

    function setFormStatusMessage(form, messageToken) {
        const messages = {
            "en-US": {
                "general": "An error occurred while trying to send your messsage. Try again later",
                "network-error": "An error occurred while trying to send your messsage. Try again later",
                "sent": "Your message is sent",
                "misconfigured": "Form is misconfigured, look in the error console for further information"
            },
            "sv-SE": {
                "general": "Ett fel uppstog vid försök att skicka ditt meddelande. Försök igen senare.",
                "network-error": "Ett fel uppstod vid försök att skicka ditt meddelande. Försök igen senare.",
                "sent": "Tack för din intresseanmälan. Någon från säljteamet kommer att kontakta dig inom kort.",
                "misconfigured": "Formuläret är felkonfigurerat, kolla i error-loggen för mer information"
            }
        }

        form.querySelectorAll('.wpcf7-response-output').forEach(div => {
            div.innerText = messages[document.documentElement.lang][messageToken];
        });
    }
})(jQuery);








